<template>
	<div class="w-full">
		<div
			class="relative mt-8 flex h-[440px] w-full flex-col overflow-clip rounded bg-gradient-to-t from-[#0076BB] via-[#2F6BCE] to-[#5F5FE1] px-6 py-6 sm:py-4 md:h-[200px] md:px-6 lg:py-6 xl:h-[230px]"
		>
			<div
				v-for="i in 4"
				:key="i"
				:class="[
					'absolute rounded-xl',
					'bg-gradient-to-b from-[#0076BB] via-[#2F6BCE] to-[#5F5FE1] opacity-15 mix-blend-multiply',
					mounted ? [`elastic-scale-up delay-${i}`] : '',
				]"
				:style="{
					top: '50%',
					left: '50%',
					height: `${30 + (i - 1) * 20}%`,
					width: `${60 + (i - 1) * 10}%`,
					transform: 'scale(0)',
				}"
			/>

			<div
				class="z-10 mt-2 flex flex-col items-center justify-around text-center md:mt-0 md:flex-row xl:m-auto xl:max-w-[900px]"
			>
				<div
					class="slide-in-from-top flex max-w-[250px] flex-col items-center gap-1 md:mt-4 md:w-fit md:max-w-[180px] md:items-start lg:mt-0 lg:w-fit lg:max-w-[250px] xl:mt-4"
				>
					<p
						class="text-center text-xl text-white md:pl-1 md:text-left md:text-lg lg:text-xl"
					>
						Sign up now and check your inbox for an exclusive gift!
					</p>
					<p
						class="px-8 pb-1.5 font-heading text-[4.5rem] leading-none tracking-widest text-white sm:px-0 md:text-[3rem] lg:text-[4.5rem]"
					>
						EOFY
					</p>
				</div>
				<CarbarImage
					image="img/campaigns/june-eofy-2025/civic.webp"
					alt-text="June EOFY Honda Civic"
					image-width-class="w-[375px]"
					image-height-class="h-auto"
					class="slide-in-from-left sm:mt-4 md:mt-0 lg:w-[375px]"
				/>
				<div
					class="slide-in-from-bottom z-10 mt-4 flex max-w-[250px] flex-col px-6 text-center sm:max-w-full md:w-1/3 md:max-w-[180px] md:px-4 lg:max-w-[250px] xl:px-4"
				>
					<p
						class="border-b border-t border-white py-4 text-2xl font-medium leading-tight text-white md:text-xl lg:px-4 lg:text-2xl"
					>
						Unlock our biggest EOFY giveaway!
					</p>
				</div>
			</div>
			<TermsAndConditions
				:is-full-width="false"
				custom-class="mt-4 md:mt-3 lg:mt-1 xl:mt-0"
				font-color="z-10 text-white text-center"
			>
				*
				<CarbarLink
					text="Terms & conditions"
					text-color="text-white hover:text-gray-200"
					underline-color="hover:decoration-gray-200"
					font-size="text-xsm"
					class="cursor-pointer"
					@click="
						goToPageAndScroll(
							'/terms-and-conditions',
							'#june-eofy-promotion',
							true
						)
					"
				/>
				apply
			</TermsAndConditions>
		</div>
	</div>
</template>

<script setup>
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const mounted = ref(false)

onMounted(() => {
	setTimeout(() => {
		mounted.value = true
	}, 50)
})
</script>
